<template>
  <div class="forum-item">
    <div class="forum-icon">
      <img :src="data.imgUrl" />
    </div>
    <div class="label">
      {{data.label}}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
  },
  data(){
    return {
    };
  },
  methods: {
  }
};
</script>

<style lang="less" scoped>
.forum-item {
  flex: 1;
  min-width: calc(20% - 24px);
  max-width: calc(20% - 24px);
  padding: 10px 24px;
  text-align: center;
  box-shadow: 0 6px 7px 0px rgba(47, 114, 245, .1);
  border-radius: 10px;
  font-size: 16px;
  line-height: 24px;
  margin: 0 12px;
  color: rgba(68, 68, 68, .6);
}
</style>